import SelfCheckInHeader from './SelfCheckInHeader';

export default SelfCheckInHeader;



// WEBPACK FOOTER //
// ./src/components/atoms/SelfCheckInHeader/index.js